import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';
import messages from './Report.intl';
import styles from './Report.module.scss';
import { STATIC_TAXONOMY } from 'common/consts/staticTaxonomy';
import { getReportURL } from 'utils/link-generator-utils';
import { convertToRoman } from 'common/utils/utils';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';
import { isOnMobile } from 'utils/device-utils';

import alternateImage from 'common/images/report_bg.svg';

@injectIntl
export default class Report extends Component {
  static defaultProps = {
    className: ''
  };

  state = {
    isMobile: isOnMobile()
  };

  static propTypes = {
    report: PropTypes.object.isRequired
  };

  alternateImageStyles = {
    backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
      alternateImage
    )})`,
    backgroundSize: '70%',
    backgroundRepeat: 'no-repeat'
  };

  @Bind()
  @Debounce(100)
  updateReportImage(params, event, a1) {
    this.setState({ isMobile: isOnMobile() });
  }

  render() {
    const {
      className,
      report: { year, period, pdfUrl, reportImage, isSimplified }
    } = this.props;
    const quarter = period.slice(-1);
    const reportUrl = getReportURL({
      year,
      period
    });

    window.addEventListener('resize', this.updateReportImage);

    return (
      <div className={`${styles.ReportBox} ${className}`}>
        {!this.state.isMobile && (
          <div className={`${styles.ImageBoxWrapper}`}>
            <div
              className={styles.ImageBox}
              style={
                reportImage
                  ? {
                      backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                        reportImage
                      )})`
                    }
                  : this.alternateImageStyles
              }
            />
          </div>
        )}
        <div className={styles.ContentBox}>
          <h2 className={styles.HeadingTitle}>
            {STATIC_TAXONOMY.REPORTS.values.YEARLY === period
              ? this.props.intl.formatMessage(messages.yearlyReport, {
                  year: year
                })
              : this.props.intl.formatMessage(messages.quarterlyReport, {
                  quarter: convertToRoman(quarter),
                  year: year
                })}
          </h2>
          <div className={styles.LinksBox}>
            {year &&
              !isSimplified && (
                <a
                  href={reportUrl}
                  className={styles.Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {this.props.intl.formatMessage(messages.watchReport)}
                </a>
              )}
            {pdfUrl &&
              pdfUrl.map((attachment, index) => {
                return (
                  <a
                    key={index}
                    href={attachment.url}
                    className={styles.Link}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                  >
                    {this.props.intl.formatMessage(messages.downloadAttachment)}
                    {attachment.name}
                  </a>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Reports/components/Report/Report.js